import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { AutoCompleteComponent, ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { ControlType } from '@app/cp/shared/enums/ControlTypes';
import { GItem } from '@app/cp/shared/models/GItem';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { CommonParam } from '../../models/CommonParam';
import { BaseMessageInfo } from '../../models/BaseMessageInfo';
import { AssignablePersonBus } from '../../models/AssignablePersonBus';

@Component({
    selector: 'person-selector',
    templateUrl: './person-selector.component.html',
    styleUrls: ['./person-selector.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PersonSelectorComponent implements OnInit {
    @ViewChild("searchAC") ac: AutoCompleteComponent;

    @Input() minSearchSize: number = 3;
    @Input() ServiceType: number = 0; //0-All, 1-Service, 2-Construction
    @Input() IsActive: boolean = true;
    @Input() DisplayValue: string = null;
    @Input() returnPerson: boolean = false;
    @Input() dontSetDisplay: boolean = false;
    @Input() excludedIds: string;
    @Output() selected: EventEmitter<any> = new EventEmitter<any>();
    data: GItem[];
    constructor(globals: GlobalsService, private svc_data: DQOIService) {

    }
    ngOnInit() {
    }
    getParameter(search: string): CommonParam {
        let param: CommonParam = new CommonParam();
        param.active = this.IsActive;
        param.addParam("ServiceType", this.ServiceType);
        param.addParam("ExcludedIds", this.excludedIds);
        param.search = search;
        return param;
    }
    filterChange(filter: string) {

        if (filter.toString().length < this.minSearchSize) {
            this.data = [];
            return;
        }
        this.setLoading(true);

        let param = this.getParameter(filter);
        this.svc_data.person_Search(param).subscribe((info: BaseMessageInfo) => {

            this.data = info.primaryReturn;
            this.setLoading(false);
        });
    }
    setLoading(loading: boolean) {
            this.ac.loading = loading;
    }
    valueChange(value: any) {
        this.DisplayValue = null;
        this.ac.reset();
        var arr: string[] = value.split("::");
        if (!this.dontSetDisplay) {
            this.DisplayValue = arr[0];
        }
        var id = arr[1];
//        this.svc_data.locationIdChanged(id);

        if (this.returnPerson === true) {
            this.svc_data.getAssignableTech(id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let dataObj: AssignablePersonBus = new AssignablePersonBus(info.primaryReturn);
                    this.selected.emit(dataObj);
                }
            })
        }
        else {
            this.selected.emit({ value: id, display: this.DisplayValue });
        }

        //if (CommonFunctions.hasValue(value)) {
        //    this.svc_data.getCustomerFromName(value).subscribe(data => {
        //        this.selected.emit(data);
        //    });
        //}
        //else {
        //    this.selected.emit(null);
        //}

    }
}
